import React from 'react';

// Página pública para onde o banco devolve o cliente depois do desafio 3D Secure (app FTApp).
// O pagamento é confirmado pelo webhook; o app confirma sozinho ao ser reaberto.
const ThreeDsReturn = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f1e35',
      color: '#e8f0fb',
      fontFamily: 'Arial, sans-serif',
      padding: 24,
      textAlign: 'center',
    }}
  >
    <div style={{ maxWidth: 420 }}>
      <div style={{ fontSize: 44, marginBottom: 12 }}>✔</div>
      <h2 style={{ margin: '0 0 12px', color: '#62DEC2' }}>Autenticação concluída</h2>
      <p style={{ margin: 0, lineHeight: 1.6 }}>
        Estamos confirmando o seu pagamento. Pode voltar ao aplicativo da Full Tour — a confirmação aparece lá em instantes.
      </p>
      <p style={{ margin: '16px 0 0', fontSize: 13, color: '#8ba5c4' }}>
        Authentication completed. We are confirming your payment — please return to the Full Tour app.
      </p>
    </div>
  </div>
);

export default ThreeDsReturn;
